import React from 'react'
import { GalleryItemModel } from './Gallery.model'

const GalleryImage = (props: GalleryItemModel) => {
  return (
    <button onClick={() => window.open(props.image, '_blank')}>
      <div className='flex items-center w-full justify-center'>
        <img src={props.image} className='h-full object-contain' alt={props.title} />
      </div>
    </button>
  )
}

export default GalleryImage